import { render, staticRenderFns } from "./AssignLabel.vue?vue&type=template&id=0c89eae9&"
import script from "./AssignLabel.vue?vue&type=script&lang=js&"
export * from "./AssignLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports